import React from "react";
import { PageWrapper, UsersContainer } from "../../containers";

const AdminDashboard = () => {
  return <PageWrapper pageContainerChildren={<UsersContainer />} />;
};

export default AdminDashboard;
